import React from 'react';
import {NavLink} from 'react-router-dom';
// import {useTranslation} from 'react-i18next';
// import {isEmpty, get} from 'lodash';
// import api from 'api';

import Button from 'components/Button';
import {ModalHeader, Row, Col, ListItem, NewPhoneOrEmailButton} from './styled';

import StyledIcon from 'components/acommon/StyledIcon';
import Modal from 'components/Modal';
import Checkbox from 'components/Checkbox';
import successImg from 'assets/img/status-success-icon.png';
// import Datepicker from 'components/Datepicker';
// import TimePicker from 'components/TimePicker';

type CheckboxesType = {
  [key: string]: boolean;
};
export enum CHECKBOXES {
  byPhone = 'phone',
  byEmail = 'email',
}

type ModalTypes = {
  reservationId?: string;
  housingId?: string;
  isOpenModalReceiveTicket: boolean;
  handleModalReceiveTicket: () => void;
};

function ModalReceiveTicket({
  // reservationId,
  // housingId,
  isOpenModalReceiveTicket,
  handleModalReceiveTicket,
}: ModalTypes) {
  const [checkboxes, setCheckboxes] = React.useState<CheckboxesType>({
    [CHECKBOXES.byPhone]: false,
    [CHECKBOXES.byEmail]: false,
  });
  // const [peopleNumber, setPeopleNumber] = React.useState<number>(1);
  // const {t} = useTranslation();
  // const handleDownloadButton = React.useCallback(async () => {
  //   console.log('reservationId', reservationId);
  //   if (!reservationId) {
  //     return;
  //   }

  //   const {data, error} = await api.documents.getContracts(
  //     `housing_sample_id=${housingId}`,
  //   );
  //   const contract = get(data, '0.file');

  //   if (contract) {
  //     window.open(contract, '__blank');
  //   }

  //   if (error) {
  //     console.log('error', error);
  //   }
  // }, [housingId, reservationId]);

  const handleCheckboxChange = (name = '') => {
    if (!name) {
      return;
    }

    setCheckboxes(prevState => {
      return {
        ...prevState,
        [name]: !prevState[name],
      };
    });
  };

  const handleModalButton = () => {
    handleModalReceiveTicket();
  };

  if (!isOpenModalReceiveTicket) {
    return null;
  }

  return (
    <Modal
      open={isOpenModalReceiveTicket}
      onClose={handleModalButton}
      closeOnDocumentClick
      closeOnEscape
      withCloseButton
      contentStyle={{padding: '50px 60px', borderRadius: '15px', maxWidth: '540px'}}
    >
      <Col>
        <ModalHeader>
          <div className="desktopImage">
            <img src={successImg} alt="Success!" />
          </div>
          <div className="modalTitle">Booked!</div>
          <div className="modalMobileTitle">
            <StyledIcon name="successIcon" size="32px" color="white" />
            <span>Requested!</span>
          </div>
          <div className="modalSubTitle">
            How would you like to receive the confirmation?
          </div>
        </ModalHeader>

        {/* <Col style={{maxWidth: '370px', width: '100%'}}></Col> */}
        <ListItem>
          <Checkbox
            onChange={handleCheckboxChange}
            name="byPhone"
            label="By text message (SMS) at +1 234 567 890"
            checked={checkboxes.byPhone}
            round
          />
        </ListItem>
        <ListItem>
          <Checkbox
            onChange={handleCheckboxChange}
            name="byEmail"
            label="By email at scarl••••••••••••@gm•••.com"
            checked={checkboxes.byEmail}
            round
          />
        </ListItem>
        <Row style={{justifyContent: 'left', paddingTop: '30px'}}>
          <NavLink to="/?signup=true">
            <NewPhoneOrEmailButton>
              <StyledIcon name="addGuest" color="#3B71FE" />
              Add phone / email
            </NewPhoneOrEmailButton>
          </NavLink>
        </Row>
        <Row style={{justifyContent: 'center', padding: '50px 0'}}>
          <Button label="Keep exploring" onClick={handleModalButton} />
        </Row>
        <Row className="goToPaymentButton">Go to payment</Row>
      </Col>
    </Modal>
  );
}

export default ModalReceiveTicket;
